// extracted by mini-css-extract-plugin
module.exports =  {"text":"mismatchTimezoneModal-module_text_ca45f","footer":"mismatchTimezoneModal-module_footer_ebf71","boldText":"mismatchTimezoneModal-module_boldText_d3acb"};